export function trigger() {
  const triggerNav = document.querySelector('.trigger-nav');
  if (triggerNav) {
    triggerNav.addEventListener('click', function (e) {
      document.body.classList.remove('is-home-image-zoom');
      if (document.body.classList.contains('is-nav-active')) {
        document.body.classList.remove('is-nav-active');
      } else {
        document.body.classList.add('is-nav-active');
      }
      e.preventDefault();
    });
  }

  const triggerReset = document.querySelectorAll('.trigger-reset');
  if (triggerReset.length) {
    for (let i = 0; i < triggerReset.length; i++) {
      const el = triggerReset[i];
      el.addEventListener('click', function (e) {
        document.body.classList.remove('is-nav-active');
        e.preventDefault();
      });
    }
  }
}